// source: io/codedrills/proto/content/preview.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js');
goog.object.extend(proto, io_codedrills_proto_judge_judge_pb);
var io_codedrills_proto_user_candidate_status_pb = require('../../../../io/codedrills/proto/user/candidate_status_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_candidate_status_pb);
goog.exportSymbol('proto.io.codedrills.proto.content.CandidatePreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentPreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CustomerPreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.MemberPreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SubmissionPreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TeamPreview', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.UserPreview', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContentPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContentPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContentPreview.displayName = 'proto.io.codedrills.proto.content.ContentPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.UserPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.UserPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.UserPreview.displayName = 'proto.io.codedrills.proto.content.UserPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CandidatePreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CandidatePreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CandidatePreview.displayName = 'proto.io.codedrills.proto.content.CandidatePreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TeamPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.TeamPreview.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.TeamPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TeamPreview.displayName = 'proto.io.codedrills.proto.content.TeamPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.MemberPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.MemberPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.MemberPreview.displayName = 'proto.io.codedrills.proto.content.MemberPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SubmissionPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.SubmissionPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SubmissionPreview.displayName = 'proto.io.codedrills.proto.content.SubmissionPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CustomerPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CustomerPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CustomerPreview.displayName = 'proto.io.codedrills.proto.content.CustomerPreview';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContentPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContentPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    url: jspb.Message.getFieldWithDefault(msg, 4, ""),
    contentType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    metaData: (f = msg.getMetaData()) && io_codedrills_proto_content_content_pb.MetaData.toObject(includeInstance, f),
    createdOn: jspb.Message.getFieldWithDefault(msg, 15, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.ContentPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContentPreview;
  return proto.io.codedrills.proto.content.ContentPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContentPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.ContentPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 11:
      var value = new io_codedrills_proto_content_content_pb.MetaData;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedOn(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContentPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContentPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      io_codedrills_proto_content_content_pb.MetaData.serializeBinaryToWriter
    );
  }
  f = message.getCreatedOn();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ContentType content_type = 5;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional MetaData meta_data = 11;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.MetaData, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
*/
proto.io.codedrills.proto.content.ContentPreview.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int64 created_on = 15;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getCreatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setCreatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 customer_id = 16;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentPreview} returns this
 */
proto.io.codedrills.proto.content.ContentPreview.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.UserPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.UserPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userImageUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    handle: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.content.UserPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.UserPreview;
  return proto.io.codedrills.proto.content.UserPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.UserPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.content.UserPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserImageUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.UserPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.UserPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHandle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.UserPreview} returns this
 */
proto.io.codedrills.proto.content.UserPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.UserPreview} returns this
 */
proto.io.codedrills.proto.content.UserPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_image_url = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.getUserImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.UserPreview} returns this
 */
proto.io.codedrills.proto.content.UserPreview.prototype.setUserImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string handle = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.UserPreview.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.UserPreview} returns this
 */
proto.io.codedrills.proto.content.UserPreview.prototype.setHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CandidatePreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CandidatePreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CandidatePreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    stage: jspb.Message.getFieldWithDefault(msg, 4, 0),
    testStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    inviteDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    rating: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CandidatePreview}
 */
proto.io.codedrills.proto.content.CandidatePreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CandidatePreview;
  return proto.io.codedrills.proto.content.CandidatePreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CandidatePreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CandidatePreview}
 */
proto.io.codedrills.proto.content.CandidatePreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (reader.readEnum());
      msg.setTestStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInviteDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRating(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CandidatePreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CandidatePreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CandidatePreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTestStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getInviteDate();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getRating();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional io.codedrills.proto.user.CandidateStage stage = 4;
 * @return {!proto.io.codedrills.proto.user.CandidateStage}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getStage = function() {
  return /** @type {!proto.io.codedrills.proto.user.CandidateStage} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.CandidateStage} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional io.codedrills.proto.user.TestStatus test_status = 5;
 * @return {!proto.io.codedrills.proto.user.TestStatus}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getTestStatus = function() {
  return /** @type {!proto.io.codedrills.proto.user.TestStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.TestStatus} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setTestStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 invite_date = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getInviteDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setInviteDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 rating = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CandidatePreview} returns this
 */
proto.io.codedrills.proto.content.CandidatePreview.prototype.setRating = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.TeamPreview.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TeamPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TeamPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    organizationsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    memberPreviewsList: jspb.Message.toObjectList(msg.getMemberPreviewsList(),
    proto.io.codedrills.proto.content.MemberPreview.toObject, includeInstance),
    contestPreview: (f = msg.getContestPreview()) && proto.io.codedrills.proto.content.ContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TeamPreview}
 */
proto.io.codedrills.proto.content.TeamPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TeamPreview;
  return proto.io.codedrills.proto.content.TeamPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TeamPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TeamPreview}
 */
proto.io.codedrills.proto.content.TeamPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrganizations(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.content.MemberPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.MemberPreview.deserializeBinaryFromReader);
      msg.addMemberPreviews(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.content.ContentPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContentPreview.deserializeBinaryFromReader);
      msg.setContestPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TeamPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TeamPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getMemberPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.content.MemberPreview.serializeBinaryToWriter
    );
  }
  f = message.getContestPreview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.content.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string organizations = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.getOrganizationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.addOrganizations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};


/**
 * repeated MemberPreview member_previews = 4;
 * @return {!Array<!proto.io.codedrills.proto.content.MemberPreview>}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.getMemberPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.MemberPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.MemberPreview, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.MemberPreview>} value
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
*/
proto.io.codedrills.proto.content.TeamPreview.prototype.setMemberPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.MemberPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.MemberPreview}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.addMemberPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.content.MemberPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.clearMemberPreviewsList = function() {
  return this.setMemberPreviewsList([]);
};


/**
 * optional ContentPreview contest_preview = 5;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.getContestPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContentPreview, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
*/
proto.io.codedrills.proto.content.TeamPreview.prototype.setContestPreview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.TeamPreview} returns this
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.clearContestPreview = function() {
  return this.setContestPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamPreview.prototype.hasContestPreview = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.MemberPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.MemberPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MemberPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    handle: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.MemberPreview}
 */
proto.io.codedrills.proto.content.MemberPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.MemberPreview;
  return proto.io.codedrills.proto.content.MemberPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.MemberPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.MemberPreview}
 */
proto.io.codedrills.proto.content.MemberPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.MemberPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.MemberPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MemberPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHandle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MemberPreview} returns this
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MemberPreview} returns this
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string handle = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.getHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MemberPreview} returns this
 */
proto.io.codedrills.proto.content.MemberPreview.prototype.setHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SubmissionPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubmissionPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    problemPreview: (f = msg.getProblemPreview()) && proto.io.codedrills.proto.content.ContentPreview.toObject(includeInstance, f),
    userPreview: (f = msg.getUserPreview()) && proto.io.codedrills.proto.content.UserPreview.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submissionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    timeTakenInMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
    memoryTakenInKb: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 10, 0),
    runId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.content.SubmissionPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SubmissionPreview;
  return proto.io.codedrills.proto.content.SubmissionPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.content.SubmissionPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ContentPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContentPreview.deserializeBinaryFromReader);
      msg.setProblemPreview(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.UserPreview;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserPreview.deserializeBinaryFromReader);
      msg.setUserPreview(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 5:
      var value = /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (reader.readEnum());
      msg.setSubmissionType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeTakenInMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemoryTakenInKb(value);
      break;
    case 8:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunId(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SubmissionPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SubmissionPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getProblemPreview();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserPreview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.UserPreview.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSubmissionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTimeTakenInMs();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMemoryTakenInKb();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getRunId();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
};


/**
 * optional fixed32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ContentPreview problem_preview = 2;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getProblemPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContentPreview, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
*/
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setProblemPreview = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.clearProblemPreview = function() {
  return this.setProblemPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.hasProblemPreview = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserPreview user_preview = 3;
 * @return {?proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getUserPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserPreview} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.UserPreview, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
*/
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setUserPreview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.clearUserPreview = function() {
  return this.setUserPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.hasUserPreview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional io.codedrills.proto.judge.Language language = 4;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional io.codedrills.proto.judge.SubmissionType submission_type = 5;
 * @return {!proto.io.codedrills.proto.judge.SubmissionType}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getSubmissionType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setSubmissionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 time_taken_in_ms = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getTimeTakenInMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setTimeTakenInMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 memory_taken_in_kb = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getMemoryTakenInKb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setMemoryTakenInKb = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional io.codedrills.proto.judge.Status status = 8;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 submitted_on = 10;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 run_id = 12;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getRunId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setRunId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double score = 13;
 * @return {number}
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview} returns this
 */
proto.io.codedrills.proto.content.SubmissionPreview.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CustomerPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CustomerPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CustomerPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CustomerPreview}
 */
proto.io.codedrills.proto.content.CustomerPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CustomerPreview;
  return proto.io.codedrills.proto.content.CustomerPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CustomerPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CustomerPreview}
 */
proto.io.codedrills.proto.content.CustomerPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CustomerPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CustomerPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CustomerPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CustomerPreview} returns this
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CustomerPreview} returns this
 */
proto.io.codedrills.proto.content.CustomerPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.io.codedrills.proto.content);
